import React, { memo } from 'react';
import { Clock, Calendar, Sparkles } from 'lucide-react';
import { EmptyState } from './EmptyState';
export function ReminiscePage() {
  return <div className="flex-1 bg-gray-100 min-h-screen" data-id="element-1560">
      <div className="px-8 py-6" data-id="element-1561">
        {/* Header */}
        <div className="flex items-center gap-3 mb-6" data-id="element-1562">
          <div className="p-2 bg-amber-100 rounded-lg" data-id="element-1563">
            <Clock className="w-6 h-6 text-amber-600" data-id="element-1564" />
          </div>
          <h1 className="text-3xl font-bold text-gray-900" data-id="element-1565">Reminisce</h1>
        </div>

        <p className="text-gray-600 mb-8" data-id="element-1566">
          Take a journey through time with your family stories and memories.
        </p>

        {/* Timeline */}
        <div className="bg-white rounded-2xl shadow-sm p-6 mb-8" data-id="element-1567">
          <h2 className="text-xl font-semibold text-gray-900 mb-6" data-id="element-1568">
            Memory Timeline
          </h2>
          <EmptyState icon={Calendar} title="Your timeline is empty" description="As you create more stories, they'll appear here in a beautiful timeline view." data-id="element-1569" />
        </div>

        {/* On This Day */}
        <div className="bg-white rounded-2xl shadow-sm p-6" data-id="element-1570">
          <h2 className="text-xl font-semibold text-gray-900 mb-6" data-id="element-1571">
            On This Day
          </h2>
          <EmptyState icon={Sparkles} title="No memories from this day" description="We'll remind you of stories and memories from past years on this day." data-id="element-1572" />
        </div>
      </div>
    </div>;
}